import { create } from 'zustand'

interface UIState {
  sidebarCollapsed: boolean
  toggleSidebar: () => void
  setSidebarCollapsed: (collapsed: boolean) => void

  // Modal state
  isModalOpen: boolean
  modalType: string | null
  modalData: any
  openModal: (type: string, data?: any) => void
  closeModal: () => void

  // Toast/notification state
  toast: {
    show: boolean
    message: string
    type: 'success' | 'error' | 'info' | 'warning'
  }
  showToast: (message: string, type: 'success' | 'error' | 'info' | 'warning') => void
  hideToast: () => void
}

export const useUIStore = create<UIState>((set) => ({
  // Sidebar
  sidebarCollapsed: false,
  toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
  setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),

  // Modal
  isModalOpen: false,
  modalType: null,
  modalData: null,
  openModal: (type, data) => set({ isModalOpen: true, modalType: type, modalData: data }),
  closeModal: () => set({ isModalOpen: false, modalType: null, modalData: null }),

  // Toast
  toast: {
    show: false,
    message: '',
    type: 'info',
  },
  showToast: (message, type) => set({ toast: { show: true, message, type } }),
  hideToast: () => set((state) => ({ toast: { ...state.toast, show: false } })),
}))
